import styled from '@emotion/styled'
import { Button, Flex } from '@collable/ui'
import { useNavigate } from 'react-router'

const ChannelManageHeader = () => {
  const navigate = useNavigate()
  const onClickBack = () => {
    navigate(-1)
  }
  return (
    <Container as="header" alignItems="center" justifyContent="flex-end">
      <Button
        size="small"
        kind="solid"
        color="neutral"
        variant="rightIcon"
        iconProps={{
          name: 'xSm',
        }}
        onClick={onClickBack}
      >
        돌아가기
      </Button>
    </Container>
  )
}

export default ChannelManageHeader

const Container = styled(Flex)`
  width: 100%;
  max-width: 1440px;
  height: 80px;
  margin: 0 auto;
  padding: 0 48px;
`
